/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { usePlaylist, useTag } from '@api/hooks';
import { InfoItem } from '@molecules';
import { pluralize } from '@utils';

const Item = ({ module, previewImg, errors }) => {
  const { tag, error } = useTag(module.content.tagId);
  const { playlist, errorPlaylist } = usePlaylist({ id: module?.content?.videoPlaylistId });
  const videos = module.content.videoIds;

  let description = pluralize(videos?.length, 'video');

  if (module.content.tagId) {
    description = error ? 'Error loading tag' : tag?.tag || 'loading tag...';
  }

  if (module.content.videoPlaylistId) {
    description = errorPlaylist ? 'Error loading tag' : playlist?.title || 'loading playlist...';
  }

  return (
    <InfoItem.WithError error={errors} size="large" image={previewImg} description={description}>
      Inside Track Video Module
    </InfoItem.WithError>
  );
};

export default Item;
